export default {
      id: "shuffle.sprite-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "sprite.svg#shuffle.sprite-usage",
      toString: function () {
        return this.url;
      }
    }